export default __webpack_public_path__ + "static/media/derekyang.282bc753.jpg";